// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","962":"store"}[chunkId] + "." + {"594":"47b67bf6","962":"cf93b076"}[chunkId] + ".js";
};